import {animate, state, style, transition, trigger} from '@angular/animations';
import {CommonModule} from '@angular/common';
import {Component, inject, input, signal} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {DurationType} from 'src/domain/enum/duration-type.enum';
import {FrequencyType} from 'src/domain/enum/frequency-type.enum';
import {DrinkOrSportHabit, SmokeHabit} from 'src/domain/patient/patient';
import {getKeyFromValue} from 'src/shared/utils/utils';

@Component({
    selector: 'app-habit',
    templateUrl: './habit.component.html',
    styleUrls: ['./habit.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        AngularSvgIconModule,
        CommonModule
    ],
    animations: [
        trigger('habitHeightAnimation', [
            state('false', style({ height: '*'})),
            state('true', style({ height: '44px'})),
            transition('true <=> false', animate('300ms'))
        ])
    ]
})
export class HabitComponent
{
    public readonly icon = input.required<string>();

    public readonly habit = input.required<SmokeHabit | DrinkOrSportHabit>();

    private readonly translate = inject(TranslateService);

    public collapsed = signal(true);

    public getHabitStateLabel(): string
    {
        let label = 'GENERAL.UNKNOWN';

        if (!!this.habit() && 'state' in this.habit())
        {
            label = `GENERAL.${this.habit()?.state ? 'YES' : 'NO'}`;
        }

        return this.translate.instant(label);
    }

    public cantExpand(): boolean
    {
        const isSmokeHabitWithoutDetails = !this.habit()?.amount && !(this.habit() as SmokeHabit)?.since;
        const isDrinkOrSportHabitWithoutDetails = !this.habit()?.amount && !(this.habit() as DrinkOrSportHabit)?.frequency;

        return !this.habit()?.state || isSmokeHabitWithoutDetails || isDrinkOrSportHabitWithoutDetails;
    }

    public getDurationLabel(): string
    {
        return this.translate.instant(`GENERAL.DURATION_TYPE.${getKeyFromValue(DurationType, (this.habit() as SmokeHabit)?.since?.durationType)}`);
    }

    public getFrequencyLabel(): string
    {
        return this.translate.instant(`GENERAL.FREQUENCY_TYPE.${getKeyFromValue(FrequencyType, (this.habit() as DrinkOrSportHabit)?.frequency)}`);
    }
}
